import React, { useEffect, useState } from "react";
import Select from "react-select";
import CityServices from "services/CityServices";

const SelectCityWithState = ({
  selectedState,
  setSelectedState,
  selectedCity,
  setSelectedCity,
  errors = {},
}) => {
  const [cityStateList, setCityStateList] = useState([]);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    const fetchCityStateData = async () => {
      try {
        const res = await CityServices.allCityState();
    
        if (res?.cities) {
         
          const list = res.cities.map((item) => ({
            cityId: Number(item.id_city),
            cityName: item.city_name,
            stateId: Number(item.id_state),
            stateName: item.state_name,
          }));
        
          setCityStateList(list);
          setCities(
            list.map((i) => ({
              label: i.cityName,
              value: i.cityId, 
            }))
          );
        }
      } catch (err) {
        console.error("Error fetching city-state data:", err);
      }
    };
    fetchCityStateData();
  }, []);

  const handleCityChange = (option) => {
    if (!option) {
      setSelectedCity(null);
      setSelectedState(null);
      return;
    }
    setSelectedCity({
      label: option.label,
      value: Number(option.value),
    });

    const match = cityStateList.find(
      (item) => item.cityId === Number(option.value)
    );

    if (match) {
      setSelectedState({
        label: match.stateName,
        value: match.stateId, // ✅ INTEGER ONLY
      });
    }
  };

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      fontSize: "0.9rem",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
  };

  return (
    <div className="grid grid-cols-6 gap-4">
      <div className="col-span-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          State <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={selectedState?.label || ""}
          readOnly
          className="w-full border rounded-md p-2 bg-gray-100 text-gray-700"
          placeholder="Auto-filled from city"
        />
        {errors?.state && (
          <p className="text-red-500 text-xs mt-1">{errors.state.message}</p>
        )}
      </div>

      <div className="col-span-3">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          City <span className="text-red-500">*</span>
        </label>
        <Select
          options={cities}
          value={selectedCity}
          onChange={(val) => handleCityChange(val)}
          placeholder="Search or choose city"
          isSearchable={true}
          styles={customStyles}
        />
        {errors?.city && (
          <p className="text-red-500 text-xs mt-1">{errors.city.message}</p>
        )}
      </div>
    </div>
  );
};

export default SelectCityWithState;
